(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-backup"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  /* ── Generate colors from color names ── */
  var GREST_COLOR_MAP = {
    'black':'#111','white':'#e0e0e0','blue':'#3b5bdb','red':'#e03131','green':'#2d9e6b',
    'gold':'#d4a017','silver':'#c0c0c0','purple':'#7c3aed','pink':'#e64980','yellow':'#fab005',
    'gray':'#808080','grey':'#808080','orange':'#f4823c','brown':'#8b4513','navy':'#1f3a5f',
    'teal':'#008080','olive':'#808000','bronze':'#cd7f32','coral':'#f4845f','skyblue':'#87ceeb',
    'azure':'#007fff','oxford':'#002147','lavender':'#c9b6e0','lavendar':'#c9b6e0','sage':'#b2c2a8',
    'space-black':'#1a1a1e','space-gray':'#52555a','space-grey':'#52555a','graphite':'#52504c',
    'midnight':'#1c1f28','midnight-green':'#16342c','midnight-black':'#1a1a2e','starlight':'#f5efe6',
    'star-light':'#f5efe6','sierra-blue':'#a7c1d9','pacific-blue':'#2e4a5e','deep-blue':'#2b3a67',
    'deep-purple':'#4a2060','alpine-green':'#4a7c59','ultramarine':'#5b6bd6','mist-blue':'#b8ccd6',
    'rose-gold':'#e0b0a0','product-red':'#c41e3a','productred':'#c41e3a','matte-black':'#2c2c2c',
    'matte-gold':'#c8a96e','light-green':'#a8d8a8','titanium':'#b0aca4','natural-titanium':'#c2bcb2',
    'desert-titanium':'#b89d7e','blue-titanium':'#5f6b7a','white-titanium':'#e8e6e0',
    'black-titanium':'#3a3a3c','green-titanium':'#6b8e7f'
  };

  function grestColorKey(colorName) {
    return (colorName || '').toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
  }

  /* Best-effort hex for any color label. Exact match first, then keyword fallback so new
     product colors still resolve to a sensible hue instead of gray. */
  function generateColorHex(colorName) {
    var key = grestColorKey(colorName);
    if (GREST_COLOR_MAP[key]) return GREST_COLOR_MAP[key];
    var n = key.replace(/-/g, ' ');
    var rules = [
      [/ultramarine|sapphire|cobalt/, '#4a52c4'], [/pacific|deep blue/, '#2e4a5e'],
      [/sierra|mist|sky|ice/, '#a7c1d9'], [/midnight green/, '#16342c'], [/midnight/, '#1c1f28'],
      [/rose ?gold/, '#e0b0a0'], [/gold|champagne|sand|desert/, '#d4a017'],
      [/graphite|space ?gr[ae]y|slate/, '#52555a'], [/space ?black|jet/, '#1a1a1e'],
      [/starlight|natural|cream|ivory|pearl/, '#e8e6e0'], [/lav[ae]nd/, '#c9b6e0'],
      [/sage|mint|alpine|forest/, '#7a9e7e'], [/coral|peach|salmon/, '#f4845f'],
      [/titanium/, '#b0aca4'], [/product ?red|scarlet|crimson/, '#c41e3a'],
      [/\bred\b/, '#e03131'], [/\bpink\b|blush/, '#e64980'], [/purple|violet|plum/, '#7c3aed'],
      [/\bteal\b/, '#008080'], [/\bgreen\b/, '#2d9e6b'], [/\bblue\b/, '#3b5bdb'],
      [/\borange\b|amber/, '#f4823c'], [/\byellow\b/, '#fab005'], [/silver|platinum/, '#c0c0c0'],
      [/\bgr[ae]y\b/, '#808080'], [/\bbrown\b|bronze|copper/, '#8b4513'],
      [/\bblack\b|onyx/, '#111'], [/\bwhite\b|snow/, '#e0e0e0']
    ];
    for (var i = 0; i < rules.length; i++) { if (rules[i][0].test(n)) return rules[i][1]; }
    return '#888';
  }

  /* ── Dynamically set CSS variables ── */
  document.addEventListener('DOMContentLoaded', function () {
    const root = document.documentElement;
    const colorSwatches = document.querySelectorAll('.grest-color-swatch');

    colorSwatches.forEach((swatch) => {
      const colorName = swatch.querySelector('span:last-child').textContent;
      const varName = '--color-' + grestColorKey(colorName);
      if (!getComputedStyle(root).getPropertyValue(varName).trim()) {
        root.style.setProperty(varName, generateColorHex(colorName));
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
